export const BASE_URL = 'https://www.bestimade.com/bestimade-server'
export const IMAGE_URL = 'https://www.bestimade.com/imade-image/'
export const FILE_URL = 'http://106.14.155.143:8080/imadeFiles/'



// WEBPACK FOOTER //
// ./src/util/_config_production.js